import { createAction } from 'redux-actions';
import {
  SALES_CHANNEL_NAME,
} from '../config/const';
import { updateShippingConfig } from './config_actions';

export const saveSalesChannelName = createAction(SALES_CHANNEL_NAME, payload => payload);

export const saveShippingOptions = terminalMetaData => async (dispatch) => {
  const { isPickup, isDelivery } = terminalMetaData;

  dispatch(updateShippingConfig({ isPickup, isDelivery }));
};



// WEBPACK FOOTER //
// ./src/actions/sales_channel_actions.js